import React from 'react'

const Submit = ({text}) => (
    <button type="submit" id="formSubmit" className="btn btn-primary">{text}</button>
)

export default Submit



// WEBPACK FOOTER //
// ./src/components/form/Submit.js